import { useMutation, useQueryClient } from '@tanstack/react-query';
import pluralize from 'pluralize';

import { parseApiError } from '@cast/api-client';
import { notify } from '@cast/design-system';
import { apiClient } from '@cast/infrastructure-api';

import { getNotificationsQueryKey } from 'hooks/queries/notifications/useGetNotificationsQuery';

export const useAckNotificationsMutation = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ids: string[]) => {
      return apiClient.notifications.ackNotifications({ body: { ids } });
    },
    onSuccess: (_, ids) => {
      queryClient.invalidateQueries({ queryKey: getNotificationsQueryKey() });
      notify.success(
        `${pluralize('Notification', ids?.length || 1)} resolved successfully`
      );
      onSuccess?.();
    },
    onError: (error) => {
      notify.error(parseApiError(error));
    },
  });
};
